import { Box } from "@mui/material";
import React from "react";

export interface HeroWaveMaskProps {
    /** Fill color (e.g. theme.palette.background.default) so the wave matches the page background */
    fill: string;
}

/** Single smooth wave masking the bottom of a hero; full width, ~80px amplitude (160px total height) */
const HeroWaveMask: React.FC<HeroWaveMaskProps> = ({ fill }) => {
    return (
        <Box
            sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                height: "clamp(56px, 12vh, 160px)",
                display: "block",
                pointerEvents: "none",
                lineHeight: 0
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1440 160"
                preserveAspectRatio="none"
                style={{ width: "100%", height: "100%", display: "block" }}
            >
                {/* One smooth sine-like wave: crest then trough across full width */}
                <path
                    fill={fill}
                    d="M0,80 C240,160 480,160 720,80 C960,0 1200,0 1440,80 L1440,160 L0,160 Z"
                />
            </svg>
        </Box>
    );
};

export default HeroWaveMask;
